module.exports = __webpack_public_path__ + "media/src/images/icons/new_tab-cca185f31c91a889e0b6a50cbe681909.svg";